import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";

const subscriptionPlanOptions = ["30 days", "60 days", "90 days", "120 days"];

function PointsCreateRewardSubscription({ data, onChange }) {
  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <CommonDropdownInput
        className="mt-4"
        label="Subscription Plan"
        value={data.timeFrame}
        onChange={(val) => onChange({ ...data, timeFrame: val })}
        options={subscriptionPlanOptions}
      />
      <CommonFreeTextInput
        value={
          data.pointsCost
            ? `pts ${Number(data.pointsCost).toLocaleString()}`
            : ""
        }
        label="Points Cost"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          onChange({ ...data, pointsCost: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateRewardSubscription;
